import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {Tag as TagType} from 'shells/tags-editor/tags-editor';

import type {
    UpdateLeadTags as UpdateLeadTagsMutation,
    UpdateLeadTagsVariables,
} from 'nutshell-graphql-types';

import UPDATE_LEAD_TAGS from '../mutations/update-lead-tags.graphql';
import GET_LEAD_TAG_MAPS from '../queries/get-lead-tag-maps.graphql';

export const useUpdateLeadTags = (): {
    updateLeadTags: (id: string, tags: TagType[]) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateLeadTags, {loading, error}] = useMutation<
        UpdateLeadTagsMutation,
        UpdateLeadTagsVariables
    >(UPDATE_LEAD_TAGS);

    return {
        updateLeadTags: (id: string, tags: TagType[]) => {
            const tagInput = tags.map((tag) => ({
                name: tag.name,
                tagType: 'LEAD',
            }));

            return updateLeadTags({
                // @ts-expect-error
                variables: {lead: {id, tags: tagInput}},
                optimisticResponse: {
                    __typename: 'Mutation',
                    updateLead: {
                        __typename: 'UpdateLeadPayload',
                        lead: {
                            __typename: 'Lead',
                            id,
                            tagMaps: {
                                __typename: 'TagMapsConnection',
                                // @ts-expect-error
                                edges: tags
                                    ? tags.map((tag) => ({
                                          __typename: 'TagMapsEdge',
                                          node: {
                                              __typename: 'Tag',
                                              id: tag.id,
                                              name: tag.name,
                                              color: tag.color,
                                              count: 0,
                                              creator: tag.creator,
                                              createdTime: tag.createdTime,
                                          },
                                          createdTime: tag.createdTime,
                                          creator: tag.creator,
                                      }))
                                    : [],
                            },
                        },
                    },
                },
                update: (proxy, mutationResults) => {
                    const updatedLead =
                        mutationResults &&
                        mutationResults.data &&
                        mutationResults.data.updateLead &&
                        mutationResults.data.updateLead.lead;

                    if (!updatedLead) return;

                    proxy.writeQuery({
                        // @ts-expect-error
                        id,
                        query: GET_LEAD_TAG_MAPS,
                        data: {
                            lead: updatedLead,
                        },
                    });
                },
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
